<script setup lang="ts">
definePageMeta({
  layout: "website",
});

// Registration is disabled — redirect to contact page
const router = useRouter();
onMounted(() => {
  router.replace("/contact");
});
</script>

<template>
  <div />
</template>
